// App-wide public settings (credit value in USD, platform fee, …).
// Fetched once at app boot and cached for the lifetime of the
// session - the values rarely change and are needed by every
// marketplace surface (pricing displays, USD <-> credit conversion).

const ns = 'SETTINGS_PUBLIC';

export const REQUEST  = ns + '_REQUEST';
export const RESPONSE = ns + '_RESPONSE';
export const FAILURE  = ns + '_FAILURE';

export const fetchRequest  = () => ({ type: REQUEST });
export const fetchResponse = (payload) => ({ type: RESPONSE, payload });
export const fetchFailure  = (payload) => ({ type: FAILURE,  payload });
